export default __webpack_public_path__ + "static/media/CampsSec.4218b0e3.png";